import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const CartBagIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} {...props}>
    <g strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.253 6.751H3.75a.75.75 0 0 0-.75.75v12.002c0 .415.336.75.75.75h16.503a.75.75 0 0 0 .75-.75V7.501a.75.75 0 0 0-.75-.75Z" />
      <path d="M8.251 9.752v-3a3.75 3.75 0 0 1 7.502 0v3" />
    </g>
  </svg>);
export default CartBagIcon;